var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoRental(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA7\x88\xEC\xBC\x93 \xED\x99\x88 B",
    clipPath: "url(#clip0_24993_11787)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 842,
    transform: "translate(-307 -308)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "body or main",
    clipPath: "url(#clip1_24993_11787)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 766,
    transform: "translate(-307 -232)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "top-container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feature-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\brow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row"
  }, /*#__PURE__*/React.createElement("g", {
    id: "item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 4390"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16 0.335204C-16 -8.50135 -8.83656 -15.6648 0 -15.6648H40C48.8366 -15.6648 56 -8.50135 56 0.335205V40.3352C56 49.1718 48.8366 56.3352 40 56.3352H-9.53674e-07C-8.83656 56.3352 -16 49.1718 -16 40.3352V0.335204Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "250403 \xE1\x84\x92\xE1\x85\xA9\xE1\x86\xB7 \xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB \xE1\x84\x81\xE1\x85\xAE\xE1\x86\xAF\xE1\x84\x8C\xE1\x85\xA5\xE1\x86\xBC\xE1\x84\x87\xE1\x85\xA9 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.2779 7.91144H8.92594C7.91766 7.91144 7.10028 8.72881 7.10028 9.7371V32.3205C7.10028 33.3288 7.91766 34.1462 8.92594 34.1462H28.2779C29.2862 34.1462 30.1036 33.3288 30.1036 32.3205V9.7371C30.1036 8.72881 29.2862 7.91144 28.2779 7.91144Z",
    fill: "#3F7349"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.2245 4.83521H7.11399C6.10571 4.83521 5.28833 5.65258 5.28833 6.66087V29.2443C5.28833 30.2526 6.10571 31.0699 7.11399 31.0699H25.2245C26.2328 31.0699 27.0502 30.2526 27.0502 29.2443V6.66087C27.0502 5.65258 26.2328 4.83521 25.2245 4.83521Z",
    fill: "#A4E4B4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.6778 23.6486H9.35961C8.85755 23.6486 8.44678 23.2379 8.44678 22.7358C8.44678 22.2337 8.85755 21.823 9.35961 21.823H22.6778C23.1799 21.823 23.5906 22.2337 23.5906 22.7358C23.5906 23.2379 23.1799 23.6486 22.6778 23.6486Z",
    fill: "#48BF66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.6778 20.0064H9.35961C8.85755 20.0064 8.44678 19.5957 8.44678 19.0936C8.44678 18.5916 8.85755 18.1808 9.35961 18.1808H22.6778C23.1799 18.1808 23.5906 18.5916 23.5906 19.0936C23.5906 19.5957 23.1799 20.0064 22.6778 20.0064Z",
    fill: "#48BF66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.6778 27.2817H9.35961C8.85755 27.2817 8.44678 26.8709 8.44678 26.3689C8.44678 25.8668 8.85755 25.456 9.35961 25.456H22.6778C23.1799 25.456 23.5906 25.8668 23.5906 26.3689C23.5906 26.8709 23.1799 27.2817 22.6778 27.2817Z",
    fill: "#48BF66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.5956 8.24918H9.52385C9.01971 8.24918 8.61102 8.65786 8.61102 9.16201V15.3784C8.61102 15.8825 9.01971 16.2912 9.52385 16.2912H22.5956C23.0997 16.2912 23.5084 15.8825 23.5084 15.3784V9.16201C23.5084 8.65786 23.0997 8.24918 22.5956 8.24918Z",
    fill: "#48BF66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.1336 35.8352C33.431 35.8352 37.7117 31.5411 37.7117 26.2571C37.7117 20.9732 33.4176 16.6791 28.1336 16.6791C22.8497 16.6791 18.5556 20.9732 18.5556 26.2571C18.5556 31.5411 22.8497 35.8352 28.1336 35.8352Z",
    fill: "#F9BD46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.5664 22.9656C24.8903 22.9656 25.1704 23.1845 25.2492 23.5084L26.2209 27.5703H26.2822L27.3502 23.4996C27.429 23.1932 27.7091 22.9744 28.033 22.9744H28.2343C28.5495 22.9744 28.8296 23.1932 28.9172 23.4996L29.9852 27.5878H30.0377L31.0094 23.5171C31.0882 23.202 31.3683 22.9744 31.6922 22.9744C32.1562 22.9744 32.4976 23.4209 32.3663 23.8673L30.8868 29.041C30.7993 29.3386 30.5279 29.5487 30.2128 29.5487H29.9326C29.6175 29.5487 29.3461 29.3386 29.2586 29.041L28.1556 25.2067H28.103L26.9913 29.041C26.9037 29.3386 26.6323 29.5487 26.3172 29.5487H26.0371C25.7219 29.5487 25.4505 29.3386 25.363 29.041L23.8835 23.8673C23.7522 23.4209 24.0936 22.9744 24.5576 22.9744L24.5664 22.9656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M32.9703 26.0121H23.297C23.0518 26.0121 22.8593 25.8195 22.8593 25.5744C22.8593 25.3292 23.0518 25.1367 23.297 25.1367H32.9703C33.2154 25.1367 33.408 25.3292 33.408 25.5744C33.408 25.8195 33.2154 26.0121 32.9703 26.0121Z",
    fill: "white"
  })))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24993_11787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 842,
    fill: "white",
    transform: "translate(-307 -308)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_24993_11787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 766,
    fill: "white",
    transform: "translate(-307 -232)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoRental);
export default __webpack_public_path__ + "static/media/auto-rental.3f671b514073e49ae3efd6dbace18f0b.svg";
export { ForwardRef as ReactComponent };